import React from 'react';
import { GameResultContainer } from '../../containers/GameResultContainer/GameResultContainer';

const GameResultPage: React.FC = () => {
  return <GameResultContainer />;
};

export default GameResultPage;
